import classNames from 'classnames';
import React, { useCallback, useEffect, useState } from 'react';
import InfiniteScroll from 'react-infinite-scroller';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { createSelector } from 'reselect';
import { logging, logPostInfo } from '../../actions/log';
import {
  cancelMineCollectOrSetup,
  getMineCollectList,
  getMineSetupList,
  setScroll,
} from '../../actions/wallpaper';
import Loading from '../../components/Loading/Loading';
import ScrollTop from '../../components/ScrollTop/ScrollTop';
import WallpaperCard from '../../components/WallpaperCard/WallpaperCard';
import Blank from './Blank';
import Nav from './Nav';
import styles from './WallpaperMine.module.less';

const labelList = [
  {
    name: 'setup',
    text: '曾用壁纸',
    tagId: 'setup',
  },
  {
    name: 'collect',
    text: '我收藏的',
    tagId: 'collect',
  },
];

const selectLogInfo = createSelector(
  state => state.log,
  log => log.logInfo,
);

const selectMineInfo = createSelector(
  state => {
    return state.wallpaper;
  },
  info => {
    return info.mineInfo;
  },
);
const selectScroll = createSelector(
  state => state.wallpaper && state.wallpaper,
  info => {
    return info.scroll;
  },
);
export default function WallpaperMine({ match }) {
  const [load, setLoad] = useState(null);
  const [active, setActive] = useState('setup');
  const logInfoData = useSelector(selectLogInfo);

  const mineInfo = useSelector(selectMineInfo);
  const scrollInfo = useSelector(selectScroll);
  const [contentElHeight, setContentElHeight] = useState(0);

  const dispatch = useDispatch();
  const history = useHistory();
  const { action } = history;

  /**
   * 统计页面浏览时长
   */
  useEffect(() => {
    const initTime = +new Date();
    return () => {
      const leaveTime = +new Date();
      dispatch(
        logging({
          category: 'I',
          action: 'View_Time',
          label: '',
          param2: {
            source: `Wallpaper_Mine||${active}`,
            source_p: logInfoData.source_p,
            source_pp: logInfoData.source_pp,
            initTime,
            leaveTime,
            time: leaveTime - initTime,
            active,
          },
        }),
      );
    };
  }, []);

  useEffect(() => {
    if (load === null) {
      setLoad(true);
    } else {
      setLoad(false);
    }
  }, [mineInfo]);
  /**
   * PUSH 滚动到最顶端
   */
  useEffect(() => {
    const el = document.getElementById('container_content');
    if (action === 'PUSH') {
      el.scrollTo(0, 0);
    }
  }, []);
  /**
   * POP 滚动到之前位置
   */
  useEffect(() => {
    const el = document.getElementById('container_content');
    if (contentElHeight && scrollInfo && scrollInfo.mineScrollTop && action === 'POP') {
      if (contentElHeight <= scrollInfo.mineScrollTop) {
        el.scrollTo(0, scrollInfo.mineScrollTop - 20);
      } else {
        el.scrollTo(0, scrollInfo.mineScrollTop);
        dispatch(
          setScroll({
            mineScrollTop: 0,
          }),
        );
      }
    }
  }, [contentElHeight]);

  useEffect(() => {
    dispatch(
      logging({
        category: 'Wallpaper',
        action: 'P_Wallpaper_Mine',
        label: '',
        param2: {
          source: `Wallpaper_Mine||${active}`,
          source_p: logInfoData.source_p,
          source_pp: logInfoData.source_pp,
          tagId: active,
        },
      }),
    );

    dispatch(
      logPostInfo({
        source: `Wallpaper_Mine||${active}`,
        source_p: logInfoData.source_p,
        source_pp: logInfoData.source_pp,
      }),
    );
    window.wpMineOpenPageTime = +new Date();
    loggingPVDuration();
  }, []);

  // 详情页面浏览时长打桩每隔30秒打一次，限制3分钟内
  const loggingPVDuration = useCallback(() => {
    const spaceTime = 30;
    setTimeout(() => {
      const diffTime = +new Date() - window.wpMineOpenPageTime;
      if (window.location.pathname.indexOf('wpmine') > -1 && diffTime < 6 * spaceTime * 1000) {
        dispatch(
          logging({
            category: 'Wallpaper',
            action: 'I_Wallpaper_Mine_ViewTime',
            label: '',
            param2: {
              source: `Wallpaper_Mine||${active}`,
              source_p: logInfoData.source_p,
              source_pp: logInfoData.source_pp,
              time: parseInt(diffTime / 1000, 10),
            },
          }),
        );
        loggingPVDuration();
      }
    }, spaceTime * 1000);
  }, [dispatch, active]);

  const requestFunc = params => {
    switch (params.tagId) {
      case 'collect':
        dispatch(getMineCollectList(params));
        break;
      default:
        dispatch(getMineSetupList(params));
        break;
    }
  };

  useEffect(() => {
    let tagId = active;
    if (match.params && match.params.tagId) {
      tagId = match.params.tagId;
      setActive(tagId);
    }

    const {
      location: { search },
    } = history;

    if (action === 'POP' && mineInfo.list.length !== 0) {
      setActive(mineInfo.pagenation.tagId);
      return;
    }
    if (!search || mineInfo.list.length === 0) {
      requestFunc({
        ...mineInfo.pagenation,
        tagId,
        skip: 0,
        refresh: true,
      });
    }
  }, []);

  const handleTags = tagId => () => {
    if (tagId === active) {
      return;
    }
    setActive(tagId);
    requestFunc({
      ...mineInfo.pagenation,
      tagId,
      skip: 0,
      refresh: true,
    });
    dispatch(
      logging({
        category: 'Wallpaper',
        action: 'C_Wallpaper_Mine_Tag',
        param2: {
          source: `Wallpaper_Mine||${active}`,
          source_p: logInfoData.source_p,
          source_pp: logInfoData.source_pp,
          tagId,
        },
      }),
    );
    dispatch(
      logPostInfo({
        source: `Wallpaper_Mine||${active}`,
        source_p: logInfoData.source_p,
        source_pp: logInfoData.source_pp,
      }),
    );
  };

  const loadMore = () => {
    if (!mineInfo.load && mineInfo.pagenation.tagId === active) {
      const params = {
        ...mineInfo.pagenation,
      };
      delete params.count;
      delete params.tagId;
      requestFunc({
        ...mineInfo.pagenation,
        tagId: active,
        refresh: false,
      });
    }
  };
  const handleCancel = async params => {
    const typeActive = active === 'collect' ? 2 : 4;
    if (typeActive !== params.type) {
      return;
    }
    const index = mineInfo.list.findIndex(item => item.wallpaperId === params.wallpaperId);
    dispatch(
      cancelMineCollectOrSetup({
        wallpaperId: params.wallpaperId,
        type: active === 'collect' ? 2 : 4,
      }),
    );
    if (index > -1 && mineInfo.list.length < mineInfo.pagenation.count) {
      requestFunc({
        ...mineInfo.pagenation,
        skip: mineInfo.pagenation.skip - 1 > 0 ? mineInfo.pagenation.skip - 1 : 0,
        tagId: active,
        refresh: false,
      });
    }
  };

  const getClassType = (index = 0) => {
    const pos = index % 2;
    if (pos === 0) {
      return 'big_space';
    }
    return 'big';
  };
  const handleSaveScrollTop = () => {
    const el = document.getElementById('container_content');
    dispatch(
      setScroll({
        mineScrollTop: el && el.scrollTop,
      }),
    );
  };

  const handleMeasureHeight = useCallback(node => {
    if (node) {
      setContentElHeight(node.clientHeight);
    }
  }, []);

  if ((load || load === null) && action !== 'POP') {
    return (
      <div className={styles.loading}>
        <Loading />
      </div>
    );
  }

  return (
    <div className={styles.wp_content} onClick={handleSaveScrollTop} ref={handleMeasureHeight}>
      <Nav active="wpmine" />
      <div className={styles.label_container}>
        {labelList.map(item => (
          <div
            key={item.tagId}
            className={classNames(styles.label_item, { [styles.active]: active === item.tagId })}
          >
            <span onClick={handleTags(item.tagId)}>{item.text}</span>
          </div>
        ))}
      </div>
      {mineInfo.pagenation.count > 0 && (
        <InfiniteScroll
          pageStart={1}
          loadMore={loadMore}
          hasMore={mineInfo.list.length < mineInfo.pagenation.count}
          loader={
            <div className="loader" key={0}>
              --加载中--
            </div>
          }
          // threshold={200}
          initialLoad={!mineInfo.list.length}
          useWindow={false}
          getScrollParent={() => document.getElementById('container_content')}
        >
          <div className={styles.mine}>
            {mineInfo.list.map((item, index) => {
              return (
                <div
                  // className={classNames(styles.mine_img, { [styles.left]: index % 2 === 0 })}
                  key={`${index}`}
                >
                  <WallpaperCard
                    wallpaper={item}
                    key={item.wallpaperId}
                    cardInfo={{
                      pageSource: 'mine',
                      pageTage: active || 'collect',
                      classType: getClassType(index),
                      isCollect: active === 'setup',
                      isWallpaper: true,
                      isPreview: true,
                      isDeleteColl: active === 'collect',
                      isDeleteUsed: active === 'setup',
                      deleteCallback: handleCancel,
                    }}
                    logInfo={{ source: `Wallpaper_Mine||${active}` }}
                  />
                </div>
              );
            })}
          </div>
          {/* {mineInfo.list.length >= mineInfo.pagenation.count && (
              <div className="loader">--到底啦--</div>
            )} */}
        </InfiniteScroll>
      )}
      {mineInfo.pagenation.count < 1 && <Blank load={mineInfo.load} />}
      {/* <div
          style={{
            position: 'fixed',
            bottom: 0,
            background: '#fff',
            height: '25px',
            zIndex: '1001',
            width: '830px',
            left: '200px',
          }}
        /> */}
      <ScrollTop />
    </div>
  );
}
